var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Record"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9995 11.9997C23.9995 18.627 18.627 23.9995 11.9997 23.9995C5.37246 23.9995 0 18.627 0 11.9997C0 5.37246 5.37246 0 11.9997 0C18.627 0 23.9995 5.37246 23.9995 11.9997ZM11.9997 22.4995C17.7986 22.4995 22.4995 17.7986 22.4995 11.9997C22.4995 6.20089 17.7986 1.5 11.9997 1.5C6.20089 1.5 1.5 6.20089 1.5 11.9997C1.5 17.7986 6.20089 22.4995 11.9997 22.4995ZM17.0242 11.9999C17.0242 14.7667 14.7813 17.0097 12.0144 17.0097C9.2476 17.0097 7.00464 14.7667 7.00464 11.9999C7.00464 9.23306 9.2476 6.9901 12.0144 6.9901C14.7813 6.9901 17.0242 9.23306 17.0242 11.9999Z",
    fill: "#EE1B34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingIcon);
export default __webpack_public_path__ + "static/media/recordingIcon.1a99047b77f570be6442bc860b3b2360.svg";
export { ForwardRef as ReactComponent };